import { createStudyShare, getSharedStudy, getStudyShares, revokeStudyShare, } from '@/lib/api/shares';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
export function useStudyShares(studyId) {
    return useQuery({
        queryKey: ['study-shares', studyId],
        queryFn: () => getStudyShares(studyId),
        enabled: !!studyId,
    });
}
export function useCreateStudyShare() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ studyId, request }) => createStudyShare(studyId, request),
        onSuccess: (_, { studyId }) => {
            queryClient.invalidateQueries({ queryKey: ['study-shares', studyId] });
        },
    });
}
export function useRevokeStudyShare() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (shareId) => revokeStudyShare(shareId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['study-shares'] });
        },
    });
}
export function useSharedStudy(token, region) {
    return useQuery({
        queryKey: ['shared-study', token, region ?? null],
        queryFn: () => getSharedStudy(token, region),
        enabled: !!token,
        retry: false,
        staleTime: 5 * 60 * 1000,
    });
}
